import Cookies from 'js-cookie';
import api from '@/libs/api'

const initState = {
  organizationId: localStorage.getItem('organizationId') || null,
  organizationProps: [],
  userGroupList: [],
  projectList: [],
  projectMembers: [],
  analystsEvents: [],
  userInfo: JSON.parse(localStorage.getItem('userInfo')) || {},
  userSequenceParam: {},        //用户行为序列请求参数
  userGroupId: null
};


const user = {
  state: initState,
  mutations: {
    RESET_user(state) {
      state = Object.assign(state, initState);
    },
    SET_ORGANIZATION_ID(state, id) {
      state.organizationId = id;
      localStorage.setItem('organizationId', id)
    },
    SET_ORGANIZATION_PROPS(state, props) {
      state.organizationProps = props
    },
    SET_USER_INFO(state, info) {
      state.userInfo = info;
      localStorage.setItem('userInfo', JSON.stringify(info))
    },
    SET_USER_GROUP_ID(state, id) {
      state.userGroupId = id;
    },
    SET_ORGANIZATION_PROPS(state, props) {
      state.organizationProps = props
    },
    SET_USER_GROUP_LIST(state, list) {
      state.userGroupList = list
    },
    SET_PROJECT_LIST(state, list) {
      state.projectList = list;
    },
    SET_PROJECT_MEMBERS(state, list) {
      state.projectMembers = list;
    },
    SET_ANALYSTS_EVENTS(state, list) {
      state.analystsEvents = list;
    },
    SET_USER_SEQUENCE(state, obj) {
      console.log(obj, 'obj?????')
      state.userSequenceParam = obj;
    },
    logout(state, vm) {
      api.logout();
      Cookies.remove('userId');
      Cookies.remove('token');
      Cookies.remove('userName');
      vm.$store.dispatch('resetState');
      // vm.$store.dispatch('resetRouter');
      // location.reload();
    }
  },
  actions: {
    setUserGroups({ state, commit }) {
      return new Promise(resolve => {
        api.getSelfGroups()
          .then(res => {
            if (res.data.status === 1) {
              commit('SET_USER_INFO', Object.assign({}, state.userInfo, res.data.fields))
              resolve()
            }
          })
      })
    }
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js